<template>
  <div>
    <headerBar :activeIndex="activeIndex"></headerBar>
    <!-- <banner :carousel="info.carousel" :Mcarousel="info.Mcarousel"></banner> -->
    <div class="recodeDetailPage">
      <div class="main-content1 pc" style="">
        <div style="width: 100%; margin: 0 auto">
          <img src="../../assets/wuyan.png" alt="" style="width: 100%" />
        </div>
        <!-- <div class="flex-center" style="margin: 20px 0">
        <div
          style="flex: 1; text-align: center"
          v-for="(item, index) of titleList" 
          :key="index"
        >
          <div
            :class="
              'select-bar ' + (type.name === item.main_title ? 'select-bg' : '')
            "
            @click="getPdf(item)"
          >
            {{ item.main_title }}
          </div>
        </div>
      </div> -->
        <div class="detail-content">
          <div v-html="detail.content"></div>
        </div>
      </div>
      <div class="main-content1 mobile" style="">
        <div class="detail-content">
          <div id="detailContent" v-html="detail.content"></div>
        </div>
      </div>
    </div>
    <footerBar></footerBar>
  </div>
</template>

<script>
import banner from "@/components/banner";
import headerBar from "@/components/header";
import footerBar from "@/components/footer";
import $ from 'jquery'
import {
  getmenudetail,
  medicallist,
  synopsislBymedicalId,
  synopsisDetail,
} from "@/api/common";
export default {
  name: "HelloWorld",
  components: { banner, footerBar, headerBar },
  data() {
    return {
      type: {
        name: "",
        id: null,
      },
      activeIndex: "medicalRecord",
      info: { carousel: "", Mcarousel: "" },
      detail: {},
      titleList: [],
    };
  },
  mounted() {
    getmenudetail({ id: 6 }).then((res) => {
      if (res.data.banner_pc_images && res.data.banner_pc_images !== "") {
        res.data.carousel = res.data.banner_pc_images.split(",");
        res.data.Mcarousel = res.data.banner_mobile_images.split(",");
      }
      this.info = res.data;
    });
    medicallist().then((res) => {
      this.titleList = res.data;
      this.type = this.$route.query.type;
      synopsisDetail({ id: this.$route.query.id }).then((res1) => {
        res1.data.content = res1.data.content.replace(
          `width="640" height="360"`,
          `width="100%" height="100%"`
        );
        this.detail = res1.data;
        console.log(this.detail)
        this.postMessage(
          this.detail.title,
          this.detail.abstract,
          window.location.href,
          this.detail.images
        );
        this.$nextTick(() => {
          $("#detailContent")
            .find("img")
            .each(function (i) {
              $(this).width("100%");
              $(this).height("100%");
            });
          $("#detailContent")
            .find("span")
            .each(function (i) {
              $(this).width("100%");
              $(this).css("left", "0");
            });
          $("#detailContent")
            .find(".MsoNormalTable")
            .each(function (i) {
              $(this).width("100%");
            });
        });
      });
      // var ids = res.data.map((item) => item.id);
      // this.getPdf
    });
    
  },
  methods: {
    getPdf(item) {
      this.type.name = item.main_title;
      this.type.id = item.id;
      synopsisDetail({ id: this.type.id }).then((res) => {
        this.detail = res.data;
      });
    },
    go() {
      var name = "medicalRecordDetail";
      this.$router.push({ name });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.recodeDetailPage .pc {
  padding-top: 100px;
  padding-bottom: 100px;
}
.detail-content {
  min-height: 600px;
  width: 80%;
  margin: 0 auto;
  background: #fff;
  padding: 10px 30px;
}
@media screen and (max-width: 750px) {
  .recodeDetailPage .mobile {
    padding-top: 0.2rem;
  }
  .detail-content {
    min-height: 3rem;
    width: calc(100% - 0.3rem);
    margin: 0 auto;
    background: #fff;
    padding: 0.1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/medicalRecord/detail.vue